_ = require 'underscore'
trackDebugEvent = require 'debug/trackDebugEvent'
parseURL = require 'url-parse'
md5 = require 'lib/md5'

module.exports = (eventType, url, data) ->
  parsed = parseURL(url)
  model = /// ^/1/([^/]*) ///.exec(parsed.pathname)[1]
  query = parsed.query.slice(1)

  trackDebugEvent _.extend
    debug_event_type: eventType
    debug_action: model
    string_key_1: 'query 1'
    string_val_1: query.slice(0, 255)
    string_key_2: 'query 2'
    string_val_2: query.slice(255, 510)
    string_key_3: 'md5 query'
    string_val_3: md5(query)
  , data



// WEBPACK FOOTER //
// ./app/scripts/debug/trackQuickloadEvent.coffee